import { Component, OnInit, input } from "@angular/core";
import { MatCard, MatCardContent, MatCardTitle } from "@angular/material/card";

@Component({
    selector: "app-skeleton-loader",
    standalone: true,
    imports: [MatCard, MatCardContent, MatCardTitle],
    templateUrl: "./skeleton-loader.component.html",
    styleUrl: "./skeleton-loader.component.scss"
})
export class SkeletonLoaderComponent implements OnInit {
    readonly sizes = input<{
    width: string;
    height: string;
}>({ width: "100%", height: "100%" });
    readonly show = input<{
    date: boolean;
    title: boolean;
    description: boolean;
    tags: boolean;
}>({ date: true, title: true, description: true, tags: true });
    readonly cardType = input<"case-card" | "knowledge-card" | "focus-card" | "course-card">("knowledge-card");
    readonly cardAmount = input<number>(1);
    readonly isFocusCard = input<boolean>(false);

    public numberOfCards: number[] = [];

    ngOnInit() {
        //makes a fake array to duplicate the skeleton loader
        this.numberOfCards = Array(this.cardAmount()).fill(0);
    }
}
